
export function withClientLabel<T extends { name?: string; surname?: string; email?: string }>(
  client: T | null | undefined,
): (T & { displayLabel: string }) | null {
  if (!client) return null;
  const name = `${client.name ?? ""} ${client.surname ?? ""}`.trim();
  return { ...client, displayLabel: [name, client.email].filter(Boolean).join(" – ") };
}
